// extracted by mini-css-extract-plugin
export var btnWrap = "style-module--btn-wrap--f6e03";
export var img = "style-module--img--10cad";
export var learn = "style-module--learn--ba82f";
export var left = "style-module--left--524cb";
export var wrap = "style-module--wrap--ca5fb";